<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="1200"
    v-model="dialog"
  >
    <template v-slot:default="dialog">
      <v-card v-if="notes">
        <v-toolbar
          color="primary"
          dark
        >

          <v-btn
            @click="handleClose(false)"
            style="margin-right: 20px;"
          >Cerrar</v-btn>
        </v-toolbar>
        <v-card-text style="padding-top: 10px;">
          <v-timeline
            dense
          >
            <v-timeline-item
              v-for="(item, index) of notes"
              :key="item.ID"
              :color="item.Color ? item.Color : 'grey'"
              fill-dot
              left
              small
            >
              <v-card class="elevation-2">
                <v-card-title style="font-size: 0.8rem;">
                  <small>{{item.UserName.toUpperCase()}} [ {{item.CD}} ]</small>
                </v-card-title>
                <v-card-text class="text-h5">
                  {{item.Note}}
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
          <v-card style="padding: 5px;">
            <v-textarea
              v-model="editedNote"
              solo
              name="input-7-4"
              label="Nueva nota"
              hide-details
            />
            <v-btn
              @click="handleSave"
              block
              style="margin-top: 5px;"
            >Añadir</v-btn>
          </v-card>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="handleClose(false)"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
import axios from 'axios'
export default {
  props: {
    apiURL: {
      type: String,
      required: true,
    },
    device: {
      type: Object,
      default: null,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    notes: [],
    editedNote: null,
  }),
  watch: {
    device (v) {
      this.editedNote = null
      this.dialog = v ? true : false
    },
    'device.ID' (v) {
      this.editedNote = null
      this.dialog = v ? true : false
    },
    dialog (v) {
      if (v) this.handleGetNotes()
    }
  },
  methods:{
    handleClose (refresh) {
      this.onClose(refresh)
    },
    handleGetNotes () {
      this.notes = []
      if (!this.device) return
      axios.get(`${this.apiURL}/v1/private/brightsign/${this.device.Network}/devices/${this.device.ID}/notes?token=${localStorage.getItem('jwt')}`)
        .then (response => {
          this.notes = response.data.map(item => {
            item.CD = this.convertTime(item.CD)
            return item
          })
        })
        .catch (error => {
          console.log(error)
        })
    },
    convertTime(v) {
      const dt = new Date(v)
      const result = `${
              dt.getDate().toString().padStart(2, '0')}/${
              (dt.getMonth()+1).toString().padStart(2, '0')}/${
              dt.getFullYear().toString().padStart(4, '0')} ${
              dt.getHours().toString().padStart(2, '0')}:${
              dt.getMinutes().toString().padStart(2, '0')}:${
              dt.getSeconds().toString().padStart(2, '0')}`

      return result === '01/01/0001 00:00:00' ? '' : result
    },
    handleSave () {
      if (!this.editedNote && this.editedNote.length === 0) {
        alert('Nota no encontrada')
        return
      }
      const body = JSON.parse(JSON.stringify(this.device))
      body.WithNotes = true
      body.DeviceID = this.device.ID
      body.Network = this.device.Network
      body.Note = this.editedNote
      axios.post(`${this.apiURL}/v1/private/brightsign/${this.device.Network}/devices/${this.device.ID}/notes?token=${localStorage.getItem('jwt')}`, body)
        .then (() => {
          this.handleClose(true)
        })
        .catch (error => {
          console.log(error)
          alert('Error')
        })
    },
  },
}
</script>

